module.exports = __webpack_public_path__ + "static/img/function-color.0d90616.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/function-color.svg
// module id = 5efZ
// module chunks = 46